import { getCanonicalUrl } from "../results/selectors";

export const canonicalUrlMiddleware = () => store => next => action => {

  next(action);
  if (action.meta && action.meta.updateCanonical) {
    const state = store.getState();
    const canonicalUrl = getCanonicalUrl(state);
    if (canonicalUrl) {
      document.querySelector('link[rel="canonical"]').setAttribute('href', canonicalUrl);
    }
  }
}